var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_32808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5714 3.69685C16.9286 3.9647 16.2857 4.17899 15.5357 4.23256C16.2857 3.80399 16.8214 3.10756 17.0893 2.30399C16.3929 2.73256 15.6429 3.00042 14.8393 3.16113C14.1964 2.4647 13.2857 2.03613 12.3214 2.03613C10.3929 2.03613 8.78572 3.5897 8.78572 5.57185C8.78572 5.8397 8.83929 6.10756 8.89286 6.37542C5.94643 6.2147 3.375 4.82185 1.60714 2.67899C1.28571 3.2147 1.125 3.80399 1.125 4.44685C1.125 5.67899 1.76786 6.75042 2.67857 7.39328C2.08929 7.39328 1.55357 7.23256 1.07143 6.9647V7.01828C1.07143 8.73256 2.30357 10.1254 3.91071 10.4468C3.58929 10.5004 3.32143 10.554 3 10.554C2.78571 10.554 2.57143 10.554 2.35714 10.5004C2.78571 11.8933 4.125 12.9111 5.625 12.9647C4.44643 13.929 2.89286 14.4647 1.23214 14.4647C0.964286 14.4647 0.642857 14.4647 0.375 14.4111C1.98214 15.3754 3.85714 15.9647 5.83929 15.9647C12.3214 15.9647 15.8571 10.6076 15.8571 5.94685C15.8571 5.78613 15.8571 5.62542 15.8571 5.51828C16.5 4.98256 17.0893 4.39328 17.5714 3.69685Z",
    fill: "#757185"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_32808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(0.427734 0.428711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cd5d43517ee7309c69dd3938a042d031.svg";
export { ForwardRef as ReactComponent };